export default __webpack_public_path__ + "static/media/Spring dream wreath.b1e703c5.jpg";